import { KPI_COLORS, useTranslation } from '@fareye/common'
import { Flex, Label, Span, styled } from '@fareye/ui'
import { isEmpty, toTileCase } from '@fareye/utils'
import React from 'react'
import {
  statusColorOption,
  stateColorOption,
  summaryColorOption
} from '@fareye/configs'

const colorOption: any = {
  ...stateColorOption,
  ...statusColorOption,
  ...summaryColorOption
}
export const FilterTab: any = styled(Flex)`
  cursor: pointer;
  ${(props: any) =>
    props.isSelected && {
      borderBottom: ` 3px solid ${'#006491'}`
    }}
`
export const CardFilterContainer = styled('div')<{ itemCount: number }>`
  display: flex;
  grid-gap: 0.5em;
  grid-template-columns: ${({ itemCount }: any) =>
    `repeat( minmax(110px , 1fr))`};
  @media (max-width: 425px) {
    grid-template-columns: ${_ => `repeat(${Math.floor(390 / 80)}, 1fr)`};
  }
`

const SummaryFilter = ({
  summaryData = [],
  summaryFilter,
  setSummaryFilter
}: any) => {
  let itemCount = summaryData.length
  let totalTrips = summaryData.filter(
    (item: any) => item.label === 'Total Trips'
  )[0]
  let totalCarriers = summaryData.filter(
    (item: any) => item.label === 'Total Carriers'
  )[0]
  const selectedIndex = summaryFilter?.label || ''
  const { t } = useTranslation()
  return (
    <CardFilterContainer itemCount={itemCount}>
      {!!totalCarriers && (
        <Flex column key={totalCarriers.label} p={2} id={totalCarriers.label}>
          <Label
            color={colorOption[totalCarriers.label]}
            style={{ textAlign: 'center', fontSize: '18px' }}
          >
            {totalCarriers.value}
          </Label>
          <Span style={{ textAlign: 'center' }} color={KPI_COLORS['default']}>
            {t(toTileCase(totalCarriers.label))}
          </Span>
        </Flex>
      )}
      {!!totalTrips && (
        <FilterTab
          column
          key={totalTrips.label}
          p={2}
          id={totalTrips.label}
          isSelected={selectedIndex === totalTrips.label}
          onClick={() => {
            setSummaryFilter(totalTrips)
          }}
        >
          <Label
            color={colorOption[totalTrips.label]}
            style={{ textAlign: 'center', fontSize: '18px' }}
          >
            {totalTrips.value}
          </Label>
          <Span style={{ textAlign: 'center' }} color={KPI_COLORS['default']}>
            {t(toTileCase(totalTrips.label))}
          </Span>
        </FilterTab>
      )}
      {summaryData
        .filter(
          (item: any) =>
            item.label !== 'Total Trips' && item.label !== 'Total Carriers'
        )
        .map((list: any) => {
          const { label, value, key } = list
          const isSelected = selectedIndex === label
          return (
            <FilterTab
              column
              key={label}
              p={2}
              id={label}
              isSelected={isSelected}
              onClick={() => {
                setSummaryFilter(list)
              }}
            >
              <Label
                color={colorOption[label]}
                style={{ textAlign: 'center', fontSize: '18px' }}
              >
                {value}
              </Label>
              <Span
                style={{ textAlign: 'center' }}
                color={KPI_COLORS['default']}
              >
                {t(toTileCase(label))}
              </Span>
            </FilterTab>
          )
        })}
    </CardFilterContainer>
  )
}

export default SummaryFilter
